var _excluded = ["appearance", "children", "icon", "iconPosition", "size", "stretched"],
    _excluded2 = ["forwardRef", "type"],
    _excluded3 = ["forwardRef", "type"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import warn from './util/warn';
import button from './components/button/button.style';
import * as iconStyles from '../styles/icon';
import appearanceStyles from '../styles/appearances';
import * as sizeStyles from '../styles/sizes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var securityWarning = warn('development');

function BaseButton(props) {
  var _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'regular' : _props$appearance,
      children = props.children,
      icon = props.icon,
      _props$iconPosition = props.iconPosition,
      iconPosition = _props$iconPosition === void 0 ? 'left' : _props$iconPosition,
      _props$size = props.size,
      size = _props$size === void 0 ? 'regular' : _props$size,
      stretched = props.stretched,
      discriminatedProps = _objectWithoutProperties(props, _excluded);

  var content = children;

  if (icon) {
    content = ___EmotionJSX(React.Fragment, null, ___EmotionJSX("span", {
      css: iconStyles.icon(size, iconPosition),
      key: "icon"
    }, icon), children && ___EmotionJSX("span", {
      css: iconStyles.label,
      key: "label"
    }, children));
  }

  var buttonCss = [button({
    type: props.type,
    stretched: stretched
  }), props.icon !== undefined && iconStyles.wrapper(iconPosition), sizeStyles[size], appearanceStyles[appearance]];

  if (discriminatedProps.type === 'link' && discriminatedProps.href) {
    var _forwardRef = discriminatedProps.forwardRef,
        _type = discriminatedProps.type,
        linkProps = _objectWithoutProperties(discriminatedProps, _excluded2);

    if (linkProps.target === '_blank' && (!linkProps.rel || !linkProps.rel.includes('noopener'))) {
      securityWarning('Security risk: missing rel="noopener" on anchor with target _blank');
    }

    return ___EmotionJSX("a", _extends({}, linkProps, {
      ref: _forwardRef,
      css: buttonCss
    }), content);
  }

  var forwardRef = discriminatedProps.forwardRef,
      _discriminatedProps$t = discriminatedProps.type,
      type = _discriminatedProps$t === void 0 ? 'button' : _discriminatedProps$t,
      buttonProps = _objectWithoutProperties(discriminatedProps, _excluded3);

  return ___EmotionJSX("button", _extends({
    type: type
  }, buttonProps, {
    ref: forwardRef,
    css: buttonCss
  }), content);
}

BaseButton.displayName = 'BaseButton';
export default BaseButton;